module.exports = __webpack_public_path__ + "08_medium_gold.2beb999d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_medium_gold.png
// module id = 3QmS
// module chunks = 0